import { render, staticRenderFns } from "./ParentSolutionLMS.vue?vue&type=template&id=98fb1812&"
import script from "./ParentSolutionLMS.vue?vue&type=script&lang=js&"
export * from "./ParentSolutionLMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports